import React from 'react';
import { IoMdCheckmarkCircle } from 'react-icons/io';
const ThankYou = () => {
  return (
    <>
      <div className="flex justify-center items-center mx-auto mt-10 mb-14 text-center text-[green]">
        <IoMdCheckmarkCircle className="h-20 w-20 lg:top-10 top-2" />
      </div>
      <div className="mx-auto lg:pt-2 md:pt-10 sm:pt-6 pt-6 lg:pb-12 pb-6">
        <p className="text-lg lg:text-2xl text-center px-6 md:px-0">
          Thank you for submitting your details. We will be in touch to confirm
          your booking shortly. Please check your email for our brochure.
        </p>
        <div className="mt-8 text-center">
          <a
            className="p-4 lg:p-5 rounded border border-solid border-red-400 hover:border-[#b70303]"
            href="/sale"
          >
            Take me home
          </a>
        </div>
      </div>
    </>
  );
};

export default ThankYou;
